<template lang="html">
  <div class="center-xs" style="overflow-x: hidden">
    <img src="/static/logos/parlay_logo.svg" alt="" class="logo" />
    <div class="pl-title title-box">
      <span>Welcome, {{ getProfile.name }}!</span>
      <br />
      <span>Let's create your first course.</span>
    </div>
    <br />
    <div class="row center-xs">
      <template v-if="getProfile.role === 'teacher'">
        <div class="col-xs-3 start-xs">
          <pl-input
            @keyup.native="error_title = ''"
            :errorMessage="error_title"
            type="text"
            labelText="Title"
            v-model="form_data.title"
          />
        </div>
        <div class="col-xs-2 start-xs">
          <pl-input
            @keyup.native="error_section = ''"
            :errorMessage="error_section"
            type="text"
            labelText="Section"
            v-model="form_data.section"
          />
        </div>
      </template>
    </div>
    <br />
    <pl-button @click.native="submitCourse" class="pl-primary">
      CREATE COURSE
    </pl-button>
    <br />
    <pl-button @click.native="logout"> LOGOUT </pl-button>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import authenticationServices from 'features/authentication/authentication.services';

  export default {
    computed: {
      ...mapGetters(['getProfile']),
    },
    methods: {
      logout() {
        try {
          window.HelpCrunch('logout');
        } catch (error) {
          console.error(error);
        }
        authenticationServices.logout();
      },
    },
    mounted() {
      window.gtag('config', 'UA-90906114-1', { page_path: '/onboarding' });
      // it's guaranteed that account is set up in state and amplitude is set up.
      // teachers only get here if they have just signed up
      this.$store.dispatch('analytics', 'teacher - sign-up');
      // this will replace above eventually. teacher - sign-up to be left for data continuity
      this.$store.dispatch(
        'analytics',
        'teacher - lands on create first course page'
      );
    },
  };
</script>

<style scoped lang="css">
  .logo {
    width: 10%;
    height: 10%;
    padding: 5em 0 0 0;
  }
  .title-box {
    padding: 70px 0 35px 0;
  }
</style>



// WEBPACK FOOTER //
// createCourse.vue?7a13e61f